<script>
  import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}
  <div class="xicu1 show-book">
    <h5>【繫辭 上】</h5>
    <p>
      天尊地卑，乾坤定矣。卑高以陳，貴賤位矣。
      動靜有常，剛柔斷矣。方以類聚，物以群分，吉凶生矣。
      在天成象，在地成形，變化見矣。
      是故，剛柔相摩，八卦相盪。鼓之以雷霆，潤之以風雨。日月運行，一寒一暑。
      乾道成男，坤道成女。乾知大始，坤作成物。乾以易知，坤以簡能。
      易則易知，簡則易從。
      易知則有親，易從則有功。有親則可久，有功則可大。可久則賢人之德，可大則賢人之業。易簡而天下之理得矣！天下之理得，而成位乎其中矣。
    </p>
    <p>
      聖人設卦，觀象繫辭焉而明吉凶，剛柔相推而生變化。
      是故，吉凶者，失得之象也；悔吝者，憂虞之象也；變化者，進退之象也；剛柔者，晝夜之象也。
      六爻之動，三極之道也。是故，君子所居而安者，易之序也。所樂而玩者，爻之辭也。是故，君子居則觀其象而玩其辭，動則觀其變而玩其占，是以「自天祐之，吉，无不利」。
    </p>
    <p>
      彖者，言乎象者也；爻者，言乎變者也；吉凶者，言乎其失得也；悔吝者，言乎其小疵也；无咎者，善補過也。
      是故，列貴賤者存乎位，齊小大者存乎卦，辨吉凶者存乎辭，憂悔吝者存乎介，震无咎者存乎悔。
      是故，卦有小大，辭有險易。辭也者，各指其所之。
    </p>
    <p>
      易與天地準，故能彌綸天地之道。仰以觀於天文，俯以察於地理，是故知幽明之故，原始反終，故知死生之說。
      精氣為物，遊魂為變，是故知鬼神之情狀，與天地相似，故不違。知周乎萬物，而道濟天下，故不過；旁行而不流，樂天知命，故不憂；
      安土敦乎仁，故能愛。範圍天地之化而不過，曲成萬物而不遺，通乎晝夜之道而知，故神无方而易无體。
    </p>
    <p>
      一陰一陽之謂道。繼之者，善也；成之者，性也。仁者見之謂之仁，知者見之謂之知，百姓日用而不知，故君子之道鮮矣。
      顯諸仁，藏諸用，鼓萬物而不與聖人同憂，盛德大業，至矣哉！
      富有之謂大業，日新之謂盛德。生生之謂易，成象之謂乾，效法之謂坤。極數知來之謂占，通變之謂事，陰陽不測之謂神。
    </p>
    <p>
      夫易，廣矣！大矣！以言乎遠，則不禦；以言乎邇，則靜而正；以言乎天地之間，則備矣！
      夫乾，其靜也專，其動也直，是以大生焉。
      夫坤，其靜也翕，其動也闢，是以廣生焉。廣大配天地，變通配四時，陰陽之義配日月，易簡之善配至德。
    </p>
    <p>
      子曰：「易其至矣乎！夫易，聖人所以崇德而廣業也。知崇禮卑，崇效天，卑法地。天地設位，而易行乎其中矣。
      成性存存，道義之門」。
    </p>

    <p>
      聖人有以見天下之賾，而擬諸其形容，象其物宜，是故謂之象。
      聖人有以見天下之動，而觀其會通，以行其典禮，
      繫辭焉以斷其吉凶，是故謂之爻。
      言天下之至賾而不可惡也，言天下之至動而不可亂也。擬之而後言，議之而後動，擬議以成其變化。
      「鳴鶴在陰，其子和之，我有好爵，吾與爾靡之。」
      子曰：「君子居其室，出其言善，則千里之外應之，況其邇者乎？
      居其室，出其言不善，則千里之外違之，況其邇者乎？言出乎身，加乎民；行發乎邇，見乎遠。
      言行，君子之樞機，樞機之發，榮辱之主也。言行，君子之所以動天地也，可不慎乎？」
      「同人先號咷而後笑」，子曰：「君子之道，或出或處，或默或語。二人同心，其利斷金，同心之言，其臭如蘭。」
      「初六：藉用白茅，无咎。」子曰：「苟錯諸地而可矣。藉之用茅，何咎之有？慎之至也。夫茅之為物薄，而用可重也。
      慎斯術也以往，其无所失矣。」
      「勞謙，君子有終，吉。」子曰：「勞而不伐，有功而不德，厚之至也，語以其功下人者也。德言盛，禮言恭。
      謙也者，致恭以存其位者也。」
      「亢龍有悔」，子曰：「貴而无位，高而无民，賢人在下位而无輔，是以動而有悔也。」
      「不出戶庭，无咎」，子曰：「亂之所生也，則言語以為階。君不密則失臣，臣不密則失身，幾事不密則害成。是以君子慎密而不出也。」
      子曰：「作易者，其知盜乎？易曰：『負且乘，致寇至。』負也者，小人之事也。乘也者，君子之器也。小人而乘君子之器，盜思奪之矣；上慢下暴，盜思伐之矣。
      慢藏誨盜，冶容誨淫。易曰：『負且乘，致寇至』，盜之招也。」
    </p>
    <p>
      天一，地二；天三，地四；天五，地六；天七，地八；天九，地十。
      天數五，地數五，五位相得而各有合。天數二十有五，地數三十，凡天地之數，五十有五，此所以成變化而行鬼神也。
      大衍之數五十，其用四十有九。分而為二以象兩，掛一以象三，揲之以四以象四時，歸奇於扐以象閏。五歲再閏，故再扐而後掛。
      「乾」之策，二百一十有六。「坤」之策，百四十有四，凡三百有六十，當期之日。
      二篇之策，萬有一千五百二十，當萬物之數也。是故，四營而成易，十有八變而成卦，八卦而小成。引而伸之，觸類而長之，天下之能事畢矣。
      顯道，神德行，是故，可與酬酢，可與祐神矣。子曰：「知變化之道者，其知神之所為乎。」
    </p>
    <p>
      易有聖人之道四焉：以言者尚其辭，以動者尚其變，以制器者尚其象，以卜筮者尚其占。
      是以君子將有為也，將有行也，問焉而以言，其受命也如嚮（響），无有遠近幽深，遂知來物。非天下之至精，其孰能與於此？
      參伍以變，錯綜其數。通其變，遂成天地之文；極其數，遂定天下之象，非天下之至變，其孰能與於此？
      易，无思也，无為也，寂然不動，感而遂通天下之故。非天下之至神，其孰能與於此？
      夫易，聖人之所以極深而研幾也。唯深也，故能通天下之志；唯幾也，故能成天下之務；唯神也，故不疾而速，不行而至。
      子曰：「易有聖人之道四焉」者，此之謂也。
    </p>

    <p>
      子曰：「夫易，何為者也？夫易，開物成務，冒天下之道，如斯而已者也。」
      是故，聖人以通天下之志，以定天下之業，以斷天下之疑。
      是故，蓍之德圓而神，卦之德方以知，六爻之義，易以貢。
      聖人以此洗心，退藏於密，吉凶與民同患。神以知來，知以藏往。其孰能與於此哉？古之聰明叡（睿）知，神武而不殺者夫！
      是以明於天之道，而察於民之故，是興神物以前民用。聖人以此齊戒，以神明其德夫！
      是故，闔戶謂之坤，闢戶謂之乾，一闔一闢謂之變，往來不窮謂之通，見乃謂之象，形乃謂之器，制而用之謂之法，利用出入，民咸用之謂之神。
      是故，易有太極，是生兩儀，兩儀生四象，四象生八卦，八卦定吉凶，吉凶生大業。
      是故，法象莫大乎天地；變通莫大乎四時；縣象著明莫大乎日月；崇高莫大乎富貴；備物致用，立成器以為天下利，莫大乎聖人；
      探賾索隱，鉤深致遠，以定天下之吉凶，成天下之亹亹者，莫大乎蓍龜。
      是故，天生神物，聖人則之；天地變化，聖人效之；天垂象，見吉凶，聖人象之；
      河出圖，洛出書，聖人則之。
      易有四象，所以示也；繫辭焉，所以告也；定之以吉凶，所以斷也。
    </p>
    <p>
      易曰：「自天祐之，吉，无不利」。子曰：「祐者，助也。天之所助者，順也；人之所助者，信也。履信思乎順，又以尚賢也。是以自天祐之，吉，无不利也。」
      子曰：「書不盡言，言不盡意。」然則聖人之意，其不可見乎？子曰：「聖人立象以盡意，設卦以盡情偽，繫辭以盡其言，變而通之以盡利，鼓之舞之以盡神。」
      乾坤，其易之縕邪？乾坤成列，而易立乎其中矣。乾坤毀，則无以見易。易不可見，則乾坤或幾乎息矣。
      是故，形而上者謂之道，形而下者謂之器，化而裁之謂之變，推而行之謂之通，舉而錯之天下之民謂之事業。
      是故，夫象，聖人有以見天下之賾，而擬諸其形容，象其物宜，是故謂之象。
      聖人有以見天下之動，而觀其會通，以行其典禮，繫辭焉以斷其吉凶，是故謂之爻。
      極天下之賾者，存乎卦；鼓天下之動者，存乎辭；化而裁之，存乎變；推而行之，存乎通；神而明之，存乎其人；默而成之，不言而信，存乎德行。
    </p>
  </div>
{:else}
  <div class="xicu1 show-book">
    <h5>【系辞 上】</h5>
    <p>
      天尊地卑，乾坤定矣。卑高以陈，贵贱位矣。
      动静有常，刚柔断矣。方以类聚，物以群分，吉凶生矣。
      在天成象，在地成形，变化见矣。
      是故，刚柔相摩，八卦相荡。鼓之以雷霆，润之以风雨。日月运行，一寒一暑。
      乾道成男，坤道成女。乾知大始，坤作成物。乾以易知，坤以简能。
      易则易知，简则易从。
      易知则有亲，易从则有功。有亲则可久，有功则可大。可久则贤人之德，可大则贤人之业。易简而天下之理得矣！天下之理得，而成位乎其中矣。
    </p>
    <p>
      圣人设卦，观象系辞焉而明吉凶，刚柔相推而生变化。
      是故，吉凶者，失得之象也；悔吝者，忧虞之象也；变化者，进退之象也；刚柔者，昼夜之象也。
      六爻之动，三极之道也。是故，君子所居而安者，易之序也。所乐而玩者，爻之辞也。是故，君子居则观其象而玩其辞，动则观其变而玩其占，是以「自天祐之，吉，无不利」。
    </p>
    <p>
      彖者，言乎象者也；爻者，言乎变者也；吉凶者，言乎其失得也；悔吝者，言乎其小疵也；无咎者，善补过也。
      是故，列贵贱者存乎位，齐小大者存乎卦，辨吉凶者存乎辞，忧悔吝者存乎介，震无咎者存乎悔。
      是故，卦有小大，辞有险易。辞也者，各指其所之。
    </p>
    <p>
      易与天地准，故能弥纶天地之道。仰以观于天文，俯以察于地理，是故知幽明之故，原始反终，故知死生之说。
      精气为物，游魂为变，是故知鬼神之情状，与天地相似，故不违。知周乎万物，而道济天下，故不过；旁行而不流，乐天知命，故不忧；
      安土敦乎仁，故能爱。范围天地之化而不过，曲成万物而不遗，通乎昼夜之道而知，故神无方而易无体。
    </p>
    <p>
      一阴一阳之谓道。继之者，善也；成之者，性也。仁者见之谓之仁，知者见之谓之知，百姓日用而不知，故君子之道鲜矣。
      显诸仁，藏诸用，鼓万物而不与圣人同忧，盛德大业，至矣哉！
      富有之谓大业，日新之谓盛德。生生之谓易，成象之谓乾，效法之谓坤。极数知来之谓占，通变之谓事，阴阳不测之谓神。
    </p>
    <p>
      夫易，广矣！大矣！以言乎远，则不御；以言乎迩，则静而正；以言乎天地之间，则备矣！
      夫乾，其静也专，其动也直，是以大生焉。
      夫坤，其静也翕，其动也辟，是以广生焉。广大配天地，变通配四时，阴阳之义配日月，易简之善配至德。
    </p>
    <p>
      子曰：「易其至矣乎！夫易，圣人所以崇德而广业也。知崇礼卑，崇效天，卑法地。天地设位，而易行乎其中矣。
      成性存存，道义之门」。
    </p>

    <p>
      圣人有以见天下之赜，而拟诸其形容，象其物宜，是故谓之象。
      圣人有以见天下之动，而观其会通，以行其典礼，
      系辞焉以断其吉凶，是故谓之爻。
      言天下之至赜而不可恶也，言天下之至动而不可乱也。拟之而后言，议之而后动，拟议以成其变化。
      「鸣鹤在阴，其子和之，我有好爵，吾与尔靡之。」
      子曰：「君子居其室，出其言善，则千里之外应之，况其迩者乎？
      居其室，出其言不善，则千里之外违之，况其迩者乎？言出乎身，加乎民；行发乎迩，见乎远。
      言行，君子之枢机，枢机之发，荣辱之主也。言行，君子之所以动天地也，可不慎乎？」
      「同人先号咷而后笑」，子曰：「君子之道，或出或处，或默或语。二人同心，其利断金，同心之言，其臭如兰。」
      「初六：藉用白茅，无咎。」子曰：「苟错诸地而可矣。藉之用茅，何咎之有？慎之至也。夫茅之为物薄，而用可重也。
      慎斯术也以往，其无所失矣。」
      「劳谦，君子有终，吉。」子曰：「劳而不伐，有功而不德，厚之至也，语以其功下人者也。德言盛，礼言恭。
      谦也者，致恭以存其位者也。」
      「亢龙有悔」，子曰：「贵而无位，高而无民，贤人在下位而无辅，是以动而有悔也。」
      「不出户庭，无咎」，子曰：「乱之所生也，则言语以为阶。君不密则失臣，臣不密则失身，几事不密则害成。是以君子慎密而不出也。」
      子曰：「作易者，其知盗乎？易曰：『负且乘，致寇至。』负也者，小人之事也。乘也者，君子之器也。小人而乘君子之器，盗思夺之矣；上慢下暴，盗思伐之矣。
      慢藏诲盗，冶容诲淫。易曰：『负且乘，致寇至』，盗之招也。」
    </p>
    <p>
      天一，地二；天三，地四；天五，地六；天七，地八；天九，地十。
      天数五，地数五，五位相得而各有合。天数二十有五，地数三十，凡天地之数，五十有五，此所以成变化而行鬼神也。
      大衍之数五十，其用四十有九。分而为二以象两，挂一以象三，揲之以四以象四时，归奇于扐以象闰。五岁再闰，故再扐而后挂。
      「乾」之策，二百一十有六。「坤」之策，百四十有四，凡三百有六十，当期之日。
      二篇之策，万有一千五百二十，当万物之数也。是故，四营而成易，十有八变而成卦，八卦而小成。引而伸之，触类而长之，天下之能事毕矣。
      显道，神德行，是故，可与酬酢，可与祐神矣。子曰：「知变化之道者，其知神之所为乎。」
    </p>
    <p>
      易有圣人之道四焉：以言者尚其辞，以动者尚其变，以制器者尚其象，以卜筮者尚其占。
      是以君子将有为也，将有行也，问焉而以言，其受命也如向（响），无有远近幽深，遂知来物。非天下之至精，其孰能与于此？
      参伍以变，错综其数。通其变，遂成天地之文；极其数，遂定天下之象，非天下之至变，其孰能与于此？
      易，无思也，无为也，寂然不动，感而遂通天下之故。非天下之至神，其孰能与于此？
      夫易，圣人之所以极深而研几也。唯深也，故能通天下之志；唯几也，故能成天下之务；唯神也，故不疾而速，不行而至。
      子曰：「易有圣人之道四焉」者，此之谓也。
    </p>

    <p>
      子曰：「夫易，何为者也？夫易，开物成务，冒天下之道，如斯而已者也。」
      是故，圣人以通天下之志，以定天下之业，以断天下之疑。
      是故，蓍之德圆而神，卦之德方以知，六爻之义，易以贡。
      圣人以此洗心，退藏于密，吉凶与民同患。神以知来，知以藏往。其孰能与于此哉？古之聪明叡（睿）知，神武而不杀者夫！
      是以明于天之道，而察于民之故，是兴神物以前民用。圣人以此齐戒，以神明其德夫！
      是故，阖户谓之坤，辟户谓之乾，一阖一辟谓之变，往来不穷谓之通，见乃谓之象，形乃谓之器，制而用之谓之法，利用出入，民咸用之谓之神。
      是故，易有太极，是生两仪，两仪生四象，四象生八卦，八卦定吉凶，吉凶生大业。
      是故，法象莫大乎天地；变通莫大乎四时；县象著明莫大乎日月；崇高莫大乎富贵；备物致用，立成器以为天下利，莫大乎圣人；
      探赜索隐，钩深致远，以定天下之吉凶，成天下之亹亹者，莫大乎蓍龟。
      是故，天生神物，圣人则之；天地变化，圣人效之；天垂象，见吉凶，圣人象之；
      河出图，洛出书，圣人则之。
      易有四象，所以示也；系辞焉，所以告也；定之以吉凶，所以断也。
    </p>
    <p>
      易曰：「自天祐之，吉，无不利」。子曰：「祐者，助也。天之所助者，顺也；人之所助者，信也。履信思乎顺，又以尚贤也。是以自天祐之，吉，无不利也。」
      子曰：「书不尽言，言不尽意。」然则圣人之意，其不可见乎？子曰：「圣人立象以尽意，设卦以尽情伪，系辞以尽其言，变而通之以尽利，鼓之舞之以尽神。」
      乾坤，其易之缊邪？乾坤成列，而易立乎其中矣。乾坤毁，则无以见易。易不可见，则乾坤或几乎息矣。
      是故，形而上者谓之道，形而下者谓之器，化而裁之谓之变，推而行之谓之通，举而错之天下之民谓之事业。
      是故，夫象，圣人有以见天下之赜，而拟诸其形容，象其物宜，是故谓之象。
      圣人有以见天下之动，而观其会通，以行其典礼，系辞焉以断其吉凶，是故谓之爻。
      极天下之赜者，存乎卦；鼓天下之动者，存乎辞；化而裁之，存乎变；推而行之，存乎通；神而明之，存乎其人；默而成之，不言而信，存乎德行。
    </p>
  </div>
{/if}

<style>
  .show-book {
    /* height: 400px; */
    font-size: 20px;
    font-weight: 300;
    padding-left: 20px;
    padding-right: 20px;
    margin-right: 10px;
    /* background-color: #eeeeff; */
    overflow-y: auto;
  }
</style>
